import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { AboutPageBG } from "@/components/site/AboutPageBG";
import { ABOUT_DESCRIPTION_BG } from "@/content/meta/AboutPageBG";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/about-us")({
  head: () => ({
    meta: [
      { title: "За Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { name: "description", content: ABOUT_DESCRIPTION_BG },
      { property: "og:title", content: "За Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { property: "og:description", content: ABOUT_DESCRIPTION_BG },
      { property: "og:type", content: "website" },
      ...ogImageMeta("bg", "/about-us", "За Perceptica"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "За Perceptica - мониторинг, MLP платформа и медиен анализ" },
      { name: "twitter:description", content: ABOUT_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/about-us" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/about-us" }),
  }),
  component: AboutPageBG,
});
